import Vue from 'vue'
import { defaultAxios } from '@/services/http'
import store from '../store/store.js'
import router from '@/router'
import { VoriantGuard } from '@/components/voriant-guard/VoriantGuard'

// Token Refresh
let isAlreadyFetchingAccessToken = false
const startedWSSConnection = false
let subscribers = []

function addSubscriber (callback) {
  subscribers.push(callback)
}

function onAccessTokenFetched (data) {
  localStorage.setItem('accessToken', data.accessToken)
  localStorage.setItem('refreshToken', data.refreshToken)
  localStorage.setItem('userInfo', JSON.stringify(data.user))
  Vue.prototype.$http.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${data.accessToken}`
  defaultAxios.defaults.headers.common[
    'Authorization'
  ] = `Bearer ${data.accessToken}`
  subscribers = subscribers.filter((callback) => callback(data.accessToken))
}

export default {
  async init () {
    if (localStorage['accessToken'] !== undefined) {
      defaultAxios.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${localStorage['accessToken']}`
    }

    defaultAxios.interceptors.response.use(
      (response) => {
        return response
      },
      (error) => {
        // const { config, response: { status } } = error
        const { config, response } = error
        const originalRequest = config

        if (response && response.status === 401) {
          if (isAlreadyFetchingAccessToken === false) {
            isAlreadyFetchingAccessToken = true
            store
              .dispatch('auth/fetchAccessToken')
              .then((response) => {
                onAccessTokenFetched(response.data.data)
              })
              .catch(() => {
                isAlreadyFetchingAccessToken = false
                return this.logout()
              })
          }

          return new Promise((resolve) => {
            addSubscriber((access_token) => {
              originalRequest.headers.Authorization = `Bearer ${access_token}`
              resolve(defaultAxios(originalRequest))
            })
          })
        } else if (response && response.status === 429) {
          //const time = response.data.data.resets
          //Notification
        }
        return Promise.reject(error)
      }
    )
  },

  refreshUserObject () {
    return defaultAxios.get('users/@me')
  },

  refreshCourseObject () {
    return defaultAxios.get('users/@me/active-course')
  },
  login (email, password, captcha) {
    return defaultAxios.post('auth/login', { email, password, captcha })
  },
  logout () {
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('accessToken')
    router.push('/login')
  },
  registerUser (first_name, last_name, email, password, recaptcha) {
    return defaultAxios.post('auth/register', {
      first_name,
      last_name,
      email,
      password,
      recaptcha
    })
  },
  refreshToken () {
    return defaultAxios
      .post('auth/refresh', {
        refresh_token: localStorage.getItem('refreshToken')
      })
      .catch(() => {
        this.logout()
      })
  }
}
